/*
 * Autocompletado y corrección de correos.
 *
 * Dominios en orden de uso real entre los clientes del taller (72 % usa
 * hotmail.com, luego gmail.com). Los errores frecuentes en la base son
 * "hotmial.com", "hotmsil.com", "hotmail" sin ".com", espacios y punto final:
 * por eso se limpia al salir del campo y se ofrece una corrección.
 */
export const DOMINIOS_FRECUENTES = [
  'hotmail.com',
  'gmail.com',
  'outlook.com',
  'yahoo.com',
  'icloud.com',
  'live.com.mx',
  'outlook.es',
  'yahoo.com.mx',
  'hotmail.es',
  'live.com',
  'prodigy.net.mx',
]

/* Sin espacios, minúsculas y sin punto final: " Ana@Hotmail.com. " → "ana@hotmail.com" */
export function normalizarCorreo(valor) {
  return String(valor ?? '')
    .replace(/\s+/g, '')
    .toLowerCase()
    .replace(/\.+$/, '')
}

/* "ana@g" → ["ana@gmail.com"]; sin "@" o sin usuario no sugiere nada. */
export function sugerenciasDeCorreo(valor, limite = 6) {
  const texto = String(valor ?? '').replace(/\s+/g, '')
  const arroba = texto.lastIndexOf('@')
  if (arroba < 1) return []
  const usuario = texto.slice(0, arroba)
  const escrito = texto.slice(arroba + 1).toLowerCase()
  return DOMINIOS_FRECUENTES.filter((d) => d.startsWith(escrito) && d !== escrito)
    .slice(0, limite)
    .map((d) => `${usuario}@${d}`)
}

/* Distancia de edición con transposiciones ("hotmial" ↔ "hotmail" = 1). */
function distancia(a, b) {
  const d = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)])
  for (let j = 1; j <= b.length; j += 1) d[0][j] = j
  for (let i = 1; i <= a.length; i += 1) {
    for (let j = 1; j <= b.length; j += 1) {
      const costo = a[i - 1] === b[j - 1] ? 0 : 1
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + costo)
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1)
      }
    }
  }
  return d[a.length][b.length]
}

/*
 * Corrección sugerida para un dominio mal escrito, o null.
 * "ana@hotmial.com" → "ana@hotmail.com"; "ana@hotmail" → "ana@hotmail.com".
 * Dominios de empresa ("taller-rm.mx") no se tocan.
 */
export function corregirCorreo(valor) {
  const correo = normalizarCorreo(valor)
  const arroba = correo.lastIndexOf('@')
  if (arroba < 1) return null
  const usuario = correo.slice(0, arroba)
  const dominio = correo.slice(arroba + 1)
  if (!dominio || DOMINIOS_FRECUENTES.includes(dominio)) return null

  // "hotmail" → "hotmail.com"
  if (!dominio.includes('.')) {
    const completo = DOMINIOS_FRECUENTES.find((d) => d.split('.')[0] === dominio)
    if (completo) return `${usuario}@${completo}`
  }

  let mejor = null
  let menor = Infinity
  for (const conocido of DOMINIOS_FRECUENTES) {
    const d = distancia(dominio, conocido)
    if (d < menor) {
      menor = d
      mejor = conocido
    }
  }
  // Hasta 2 errores, y solo en dominios con largo parecido a uno conocido
  return menor <= 2 && dominio.length >= 6 ? `${usuario}@${mejor}` : null
}
